import { FunctionComponent } from 'react';

import { Props } from './index';
import StyledComponent from './styles';

const Accordion: FunctionComponent<Props> = ({
    details,
    summary,
    active,
}) => {
    return (
        <StyledComponent className='accordion'>
            <div className="details">
                <div className={`summary ${active ? 'active' : ''}`}>
                    {summary}
                    {active
                        ? (
                            <span
                                className="accordion-marker"
                                style={{ transform: 'rotate(45deg)' }}
                            />
                        )
                        : (<span className="accordion-marker" />)
                    }
                </div>
                {active && (
                    <div
                        className="description"
                        dangerouslySetInnerHTML={{ __html: details }}
                    />
                )}
            </div>
        </StyledComponent>
    );
};

export default Accordion;